export default {
   apiHost: 'https://solus-api.lambdatech.com.br/',

   //apiHost: 'http://localhost:3000/',

   decimalPlaces: 2,
}



//////////////////
// WEBPACK FOOTER
// ./configuration.js
// module id = 59
// module chunks = 17